module.exports = __webpack_public_path__ + "img/knsu_main1.98e3345c.jpg";